import { useEffect } from "react";

const FORWARDED_EVENTS = ["wheel", "pointermove", "keydown"] as const;

export function useForwardSlottedEvents(viewport: HTMLElement | null): void {
  useEffect(() => {
    const root = viewport?.getRootNode();

    if (!viewport || !(root instanceof ShadowRoot)) {
      return;
    }

    const host = root.host as HTMLElement;

    const forward = (event: Event) => {
      const origin = event.composedPath()[0];

      if (origin instanceof Node && origin.getRootNode() === root) {
        return;
      }

      viewport.dispatchEvent(new Event(event.type, { bubbles: true }));
    };

    const leave = (event: PointerEvent) => {
      viewport.dispatchEvent(
        new PointerEvent("pointerout", {
          bubbles: true,
          pointerId: event.pointerId,
          pointerType: event.pointerType,
          relatedTarget: event.relatedTarget,
        }),
      );
    };

    for (const type of FORWARDED_EVENTS) {
      host.addEventListener(type, forward, { passive: true });
    }
    host.addEventListener("pointerleave", leave);

    return () => {
      for (const type of FORWARDED_EVENTS) {
        host.removeEventListener(type, forward);
      }
      host.removeEventListener("pointerleave", leave);
    };
  }, [viewport]);
}
